import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { useIsFetching, useIsMutating } from 'react-query'
import LazyLoadPage from './components/LazyLoadPage'
import LoadingBackdrop from './components/LoadingBackdrop'
import SearchPage from './pages/SearchPage'
import RequestPage from './pages/RequestPage'
import ErrorPage from './pages/ErrorPage'

const App: React.FC = () => {
  const isFetching = useIsFetching()
  const isMutating = useIsMutating()

  return (
    <BrowserRouter basename='trace'>
        <Routes>
          <Route path={`/`} element={<LazyLoadPage><SearchPage /></LazyLoadPage>} />
          <Route path={`/search/`} element={<LazyLoadPage><SearchPage /></LazyLoadPage>} />
          <Route path={`/search/:invoiceNoList`} element={<LazyLoadPage><SearchPage /></LazyLoadPage>} />
          <Route path={`/request/:invoiceNo`} element={<LazyLoadPage><RequestPage /></LazyLoadPage>} />
          <Route path={`*`} element={<ErrorPage />} />
        </Routes>

        <LoadingBackdrop loading={isFetching > 0 || isMutating > 0} />
    </BrowserRouter>
  )
}

export default App
